module.exports = __webpack_public_path__ + "static/img/img8.0d0935e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partnerLogo/img8.png
// module id = H4y3
// module chunks = 1